import axiosInstance from "../../plugins/axios-common";

export default {
  namespaced: true,
  state: {
    isAuth: false,
    employees: [],
    workshop: {},
    availableDirections: [],
    chosenDirection: null,
    url: "/",
    centrifuge: null,
    centrifugeConnecting: true,
  },
  mutations: {
    setChosenDirection (state, newState) {
      state.chosenDirection = newState
    },
    setCentrifuge(state, payload) {
      state.centrifuge = payload;
    },
    setConnectingState(state, payload) {
       state.centrifugeConnecting = payload;
    },
    addWorkshop(state, payload) {
      state.workshop = JSON.parse(JSON.stringify(payload));
    },
    addEmployees(state, payload) {
      state.employees = JSON.parse(JSON.stringify(payload));
    },
    setIsAuth(state, payload) {
      state.isAuth = payload;
    },
  },
  actions: {
    checkAuth({ commit }) {
      return new Promise((resolve, reject) => {
        let AuthToken = sessionStorage.getItem("Authorization");
        if (AuthToken) {
          axiosInstance.defaults.headers.common["Authorization"] = AuthToken;
          commit("setIsAuth", true);
          resolve("ok");
        } else {
          reject(new Error("No token in storage"));
        }
      });
    },
    getWorkshop({ commit, state }) {
      return new Promise((resolve, reject) => {
        axiosInstance({
          method: "get",
          url: "api/cash/login/workshop",
        })
          .then((response) => {
            commit("addWorkshop", response.data);
            if (state.availableDirections.length === 0) {
              if (response.data.tirefitting) {
                state.availableDirections.push({
                  slug: "tyre",
                  serviceName: 'tirefitting',
                  name: 'Шиномонтаж',
                  icon: '/images/directions/tire.jpg'
                })
              }
              if (response.data.carwash) {
                state.availableDirections.push({
                  slug: "wash",
                  serviceName: 'carwash',
                  name: 'Мойка',
                  icon: '/images/directions/carwash.jpg'
                })
              }
              if (response.data.service) {
                state.availableDirections.push({
                  slug: "service",
                  serviceName: 'service',
                  name: 'Сервис',
                  icon: '/images/directions/service.jpg'
                })
              }
              if (response.data.acrefill) {
                state.availableDirections.push({
                  slug: "acrefill",
                  serviceName: 'acrefill',
                  name: 'Кондиционер',
                  icon: '/images/directions/air.jpg'
                })
              }
              if (response.data.wheelsalign) {
                state.availableDirections.push({
                  slug: "wheelsalign",
                  serviceName: 'wheelsalign',
                  name: 'Развал-схождение',
                  icon: '/images/directions/wheelsalign.png'
                })
              }
              if (response.data.inspection) {
                state.availableDirections.push({
                  slug: "inspection",
                  serviceName: 'inspection',
                  name: 'Техосмотр',
                  icon: '/images/directions/inspection.png'
                })
              }
              if (response.data.additional) {
                state.availableDirections.push({
                  slug: "additional",
                  serviceName: 'additional',
                  name: 'Доп. услуги',
                  icon: '/images/directions/shop.jpg'
                })
              }
              state.chosenDirection = state.availableDirections[0].serviceName
            }
            resolve(response.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    getWorkshopPosts ({state}) {
      return new Promise((resolve, reject) => {
        axiosInstance({
          method: "get",
          url: process.env.VUE_APP_BOOKINURL +
              "/workshops/" +
              state.workshop.public_id + "/posts"
        })
            .then((response) => {
              resolve(response.data);
            })
            .catch((e) => {
              reject(e);
            });
      });
    },
    getWorkshopBookings ({state}, newdate=null) {
      return new Promise((resolve, reject) => {
        const date = newdate ? new Date(newdate) : new Date();
        axiosInstance({
          method: "get",
          url: process.env.VUE_APP_BOOKINURL +
              "/workshops/bookings?workshop_id=" +
              state.workshop.public_id + "&date=" +
              date.toISOString().split('T')[0],
        })
            .then((response) => {
              resolve(response.data);
            })
            .catch((e) => {
              reject(e);
            });
      });
    },
    getAllEmps({ commit }) {
      return new Promise((resolve, reject) => {
        axiosInstance({
          method: "get",
          url: "api/cash/login/employees", //todo сделать нормальную ссылку без cashbox
        })
          .then((response) => {
            console.log("Emploees:", response.data);
            commit("addEmployees", response.data);
            resolve(response.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    getSmsCode(_, [userId, phoneForgotten]) {
      return new Promise((resolve, reject) => {
        var bodyFormData = new FormData();
        bodyFormData.set("userId", userId);
        bodyFormData.set("phoneForgotten", phoneForgotten);
        axiosInstance({
          method: "post",
          url: "getotp",
          data: bodyFormData,
          headers: {
            Accept: "multipart/form-data",
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            console.log("response:", response);
            resolve(response.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    checkAuthData({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        console.log("payload", payload);
        const authData = { email: payload.email, password: payload.password };
        console.log("authData", authData);
        axiosInstance({
          method: "post",
          url: "/api/cash/login",
          data: authData,
        })
          .then((response) => {
            if (response.status === 200 && response.data.token) {
              axiosInstance.defaults.headers.common[
                "Authorization"
              ] = `Bearer ${response.data.token}`;
              sessionStorage.setItem(
                "Authorization",
                `Bearer ${response.data.token}`
              );
              sessionStorage.setItem("WSToken", response.data.ws_token);
              sessionStorage.setItem("WSUri", response.data.ws_uri);
              sessionStorage.setItem("WSChannel", response.data.ws_channel);
              sessionStorage.setItem("WSClientIp", response.data.ws_client_ip);

              commit("setIsAuth", true);
            }
            state.auth = true;
            resolve(response.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    VerifySmsCode({ state, commit }, [userId, code, phoneForgotten]) {
      return new Promise((resolve, reject) => {
        var bodyFormData = new FormData();
        bodyFormData.set("userId", userId);
        bodyFormData.set("code", code);
        bodyFormData.set("phoneForgotten", phoneForgotten);
        axiosInstance({
          method: "post",
          url: "otplogin",
          data: bodyFormData,
          headers: {
            Accept: "multipart/form-data",
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            console.log("response:", response);
            if (response.status === 200 && response.data.token) {
              axiosInstance.defaults.headers.common[
                "Authorization"
              ] = `Bearer ${response.data.token}`;
              sessionStorage.setItem(
                "Authorization",
                `Bearer ${response.data.token}`
              );
              sessionStorage.setItem("WSToken", response.data.ws_token);
              sessionStorage.setItem("WSUri", response.data.ws_uri);
              sessionStorage.setItem("WSChannel", response.data.ws_channel);
              sessionStorage.setItem("WSClientIp", response.data.ws_uid);

              commit("setIsAuth", true);
            }
            state.auth = true;
            resolve(response.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        axiosInstance({
          method: "POST",
          url: "/api/logout",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then(() => {
            delete axiosInstance.defaults.headers.common.Authorization;
            sessionStorage.removeItem("Authorization");
            sessionStorage.removeItem("WSToken");
            sessionStorage.removeItem("WSClientIp");
            commit("setIsAuth", false);
            resolve("logout complete");
          })
          .catch((e) => {
            console.log("logOutError", e);
            reject(e);
          });
      });
    },
  },
  getters: {
    workshopInfo(state) {
      return state.workshop;
    },
    chosenDirection(state) {
      return state.chosenDirection;
    },
    chosenDirectionSlug(state) {
      if (state.availableDirections && state.availableDirections.length > 1) {
        const finded = state.availableDirections.find((dir) => {
          return dir.serviceName === state.chosenDirection
        })
        return finded ? finded.slug : ''
      } else {
        return '111-'
      }
    },
    centrifugeConnecting (state) {
      if (!state.isAuth) return false
      return state.centrifugeConnecting
    }
  }
};
